import { PAGE_TYPE_PRODUCT } from 'shared/consts'
import { PDP_CSW_POSITION_CHANGE } from 'shared/experiments/consts'
import { trackCswSlider } from 'shared/experiments/consts/trackCswSlider'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import store from 'shared/store'
import { isMobile } from 'shared/utils/deviceClassUtils'

export default () => {
  const { isEnabled } = getExperimentOnClient(PDP_CSW_POSITION_CHANGE)
  const pageType = store.getState()?.publicRuntimeConfig.pageProperties.pageType
  const deviceClass =
    store.getState()?.publicRuntimeConfig.publicConfig.deviceClass
  const isMobileDevice = isMobile(deviceClass)

  if (!isEnabled || pageType !== PAGE_TYPE_PRODUCT || !isMobileDevice) return

  void activateExperiment(PDP_CSW_POSITION_CHANGE)

  trackCswSlider({})
}
